export const list = (dispatch, apiClient, from, to, skip, reset) => {
  dispatch({ type: 'LOGS_PENDING' });
  return apiClient
    .call({
      endpoint: 'logs/list',
      data: { from, to, skip }
    })

    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'LOGS_LIST', data: res.data, from, to, skip, reset });
    })
    .catch(e => {
      dispatch({ type: 'LOGS_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't get logs list",
        snackType: 'warning'
      });
      throw e;
    });
};

export const eslint = 'Stop complaining, i do what i want';



// WEBPACK FOOTER //
// ./app/actions/logs.js